import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Uploader from '../components/Uploader';

import { createFilesPool, removeFilesPool, uploadRequest, removeFile } from '../services/actions';
import { selectFileList } from '../services/selectors';

export default compose(
    connect(
        (state, { name }) => ({
            fileList: selectFileList(state, name),
        }),
        (dispatch, { name }) => ({
            create: bindActionCreators(createFilesPool, dispatch),
            remove: bindActionCreators(removeFilesPool, dispatch),
            handleRequest: ({ file }) => {
                dispatch(uploadRequest(name, file));
            },
            handleRemove: file => {
                dispatch(removeFile(name, file.uid));
            },
        }),
    ),
)(Uploader);
